import { Box, Typography } from "@mui/material";
import React from "react";
import * as styles from "./posterTimedContentStyles";
import Welcome from "../Welcome/Welcome";
import { useCountdown } from "../../../hooks/useCountdown";
import { formatCountdown } from "../../../utils/timeUtils";
import { REVEAL_DATE } from "../../../constants/time-constants";

const PosterTimedContent: React.FC = () => {
    const { timeRemaining, isRevealed } = useCountdown(REVEAL_DATE);

    return (
        <Box sx={styles.container}>
            <Typography sx={styles.introText}>
                Am 14. Februar 2026 spielte
            </Typography>

            <Typography sx={styles.factText}>
                der Hamburger SV sein{" "}
                <Box component="span" sx={styles.highlightNumber}>
                    1887.
                </Box>{" "}
                Bundesligaspiel
            </Typography>

            <Welcome />

            {!isRevealed ? (
                <>
                    <Typography sx={styles.revealedText1}>
                        SEIT{" "}
                        <Box component="span" sx={styles.highlightNumber}>
                            1887
                        </Box>{" "}
                        SCHREIBT DER VEREIN GESCHICHTE.
                    </Typography>
                    <Typography sx={styles.revealedText2}>
                        DIESER MOMENT BEKOMMT EIN ZEICHEN.
                    </Typography>

                    <Box sx={styles.timedBox}>
                        <Box sx={styles.timeContainer}>
                            <Typography sx={styles.timeNumber}>
                                18:87
                            </Typography>
                            <Typography sx={styles.timeLabel}>Uhr</Typography>
                        </Box>

                        <Typography sx={styles.countdownLabel}>
                            Enthüllung in:
                        </Typography>

                        <Box sx={styles.countdownBox}>
                            <Typography sx={styles.countdownText}>
                                {formatCountdown(timeRemaining)}
                            </Typography>
                        </Box>
                    </Box>
                </>
            ) : (
                <Box sx={styles.videoContainer}>
                    <video
                        src={"/videos/1887-reveal.mov"}
                        playsInline
                        controls
                        style={styles.video}
                    />
                </Box>
            )}
        </Box>
    );
};

export default PosterTimedContent;
